import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalData } from 'src/app/model/campaign';
import { NgForm, Validators } from '@angular/forms'; // Import NgForm

@Component({
  selector: 'app-create-campaign-modal',
  templateUrl: './create-campaign-modal.component.html',
  styleUrls: ['./create-campaign-modal.component.scss']
})
export class CreateCampaignModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) { }

  @Output() dataAdded: EventEmitter<ModalData> = new EventEmitter<ModalData>();
  @Input() modalData: ModalData = { campaignName: '' };
  @Input() duplicateCampaignNameError:any = null;
  displayError: boolean= false;

  // Use ViewChild to access the form
  @ViewChild('form', { static: true }) form: NgForm;

  ngOnInit() {
    // this.form.controls['campaignName'].setValidators([Validators.minLength(6)])
  }

  addData() {
    this.displayError = true;
    Object.values(this.form.controls).forEach(control => {
      control.markAsTouched();
    });
    this.form.controls['campaignName'].markAsTouched();
    // Check if the form is valid before emitting the data
    if (this.form.valid) {
      // Emit the data to the parent component
      this.dataAdded.emit(this.modalData);
      // Close the modal
      // this.activeModal.close();
      this.displayError = false;
    }
  }

  closeModal() {
    // Close modal
    this.displayError = false;
    this.activeModal.dismiss();
  }
}
